<template>
<select v-model="selectedCountry">
  <option value="">{{ $t('common.select' )}}</option>
  <option v-for="(country) in countries" :value="country.iso" :key="country.idx">
    <template v-if="$root.$i18n.locale === 'zh-Hant'">
      {{ country.name_cht }} +{{ country.code }}
    </template>
    <template v-else>
      {{ country.name }} +{{ country.code }}
    </template>
  </option>
</select>
</template>

<script>
import Axios from '@/helpers/axios';

export default {
  name: 'Country-Select',
  props: ['defaultCountry'],
  data() {
    return {
      countries: [
        {
          idx: '2',
          name: 'Taiwan',
          name_cht: '\u53f0\u7063',
          code: '886',
          iso: 'TW',
          emoji: '\ud83c\uddf9\ud83c\uddfc',
          sort: '20',
        },
      ],
      selectedCountry: this.defaultCountry,
    };
  },
  mounted() {
    const data = {
      lang: this.$i18n.locale,
    };

    Axios({
      method: 'post',
      url: '/api/getCountryCode',
      data,
    })
      .then((response) => {
        this.countries = response.data;
      });
  },
  watch: {
    selectedCountry(value) {
      this.$emit('select-country', value);
    },
  },
};
</script>
